/**
 * Asynchronously loads the component for OfferLetterTemplates
 */

import loadable from 'utils/loadable';

export const OfferLetterTemplates = loadable(() => import('./index'), {
  fallback: null,
});
